import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import HomePage4 from '../HomePage4/HomePage4';
import AboutPage from '../AboutPage/AboutPage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectPage2 from '../ProjectPage2/ProjectPage2';
import ProjectSingle from '../ProjectSingle/ProjectSingle';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import ShopPage from '../ShopPage'
import ProductSinglePage from '../ProductSinglePage';
import CartPage from '../CartPage';
import CheckoutPage from '../CheckoutPage';
import OrderRecived from '../OrderRecived';
import PricingPage from '../PricingPage/PricingPage';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import ContactPage from '../ContactPage/ContactPage';

import ErrorPage from '../ErrorPage/ErrorPage';
import HomeInteriorsPage from '../HomeInteriorsPage/HomeInteriorsPage';
import CommercialInteriorsPage from '../CommercialInteriors/CommercialInteriorsPage';
import OfficeInteriorsPage from '../OfficeInteriors/OfficeInteriorsPage';
import ElectricallightingPage from '../ElectricalLightingPage/ElectricalLightingPage';
import PaintingWorkPage from '../PaintingWorkPage/PaintingWorkPage';
import PlumbingWorkPage from '../PlumbingWorkPage/PlumbingWorkPage';
import RenovationWorkPage from '../RenovationWorkPage/RenovationWorkPage';
import CarpentryWorkPage from '../CarpentryWorkPage/CarpentryWorkPage';
import GalleryPage from '../GalleryPage/GalleryPage';
import AboutPage2 from '../AboutPage2/AboutPage2';
import PrivacyPage from '../PrivacyPage/PrivacyPage';
import TermsPage from '../TermsPage/TermsPage';
// import ShopPage from '../ShopPage'
// import LoginPage from '../LoginPage';
// import SignUpPage from '../SignUpPage';
// import ForgotPassword from '../ForgotPassword';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="home-2" element={<HomePage2 />} />
          <Route path="home-3" element={<HomePage3 />} />
          <Route path="home-4" element={<HomePage4 />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="about2" element={<AboutPage2 />} />
          <Route path="project-1" element={<ProjectPage />} />
          <Route path="project-2" element={<ProjectPage2 />} />
          <Route path="project-single/:slug" element={<ProjectSingle />} />
          <Route path="service" element={<ServicePages />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:slug" element={<TeamSinglePage />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path='product-single/:slug' element={<ProductSinglePage />} />
          <Route path='cart' element={<CartPage />} />
          <Route path='checkout' element={<CheckoutPage />} />
          <Route path='order_received' element={<OrderRecived />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left-sidebar' element={<BlogPageLeft />} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='blog-single/:slug' element={<BlogDetails />} />
          <Route path='blog-single-left-sidebar/:slug' element={<BlogDetailsLeftSiide />} />
          <Route path='blog-single-fullwidth/:slug' element={<BlogDetailsFull />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='homeinteriors' element={<HomeInteriorsPage />} />
          <Route path='commercialinteriors' element={<CommercialInteriorsPage />} />
          <Route path='officeinteriors' element={<OfficeInteriorsPage />} />
          <Route path='electricallighting' element={<ElectricallightingPage />} />
          <Route path='paintingwork' element={<PaintingWorkPage />} />
          <Route path='plumbingwork' element={<PlumbingWorkPage />} />
          <Route path='renovationwork' element={<RenovationWorkPage />} />
          <Route path='Carpentryworks' element={<CarpentryWorkPage />} />
          <Route path='gallery' element={<GalleryPage />} />
          <Route path='privacypolicy' element={<PrivacyPage />} />
          <Route path='termsconditions' element={<TermsPage />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
